import React from "react";
import { FiZap, FiGlobe } from "react-icons/fi";
import {
  LuSettings,
  LuUsers,
  LuSmartphone,
  LuShieldCheck,
  LuPercent,
  LuShield,
  LuBuilding2,
  LuCircleCheck,
  LuSearch,
  LuLayers,
  LuCpu,
  LuPalette,
  LuCode,
  LuBug,
  LuRocket,
} from "react-icons/lu";

export const IonicAppHeroData = {
  backgroundImage: "/images/serviceBanners/IonicBanner.webp",
  whiteImage: "/images/serviceBanners/IonicBannerW.webp",
  subTitle: "Ionic App Development Services",
  title: (
    <>
      Web Power Meets <br /> Native <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-600">Performance</span>
    </>
  ),
  description:
    "We build high performance Ionic applications using HTML, CSS, and JavaScript to deliver scalable, cross platform apps that work seamlessly across iOS, Android, and web with native like performance and smooth user experience.",
  primaryButton: {
    title: "Get a Free Quote",
    onClick: () => console.log("Ionic Quote clicked"),
  },
  secondaryButton: {
    title: "View Our Work",
    onClick: () => console.log("Ionic Work clicked"),
  },
  featureData: [
    {
      icon: "/images/services/website/high_performance.webp",
      title: "Web Standards",
      desc: "Built using HTML, CSS, and JavaScript for reliable performance.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/responsive.webp",
      title: "Cross-Platform Support",
      desc: "Run seamlessly on iOS, Android, and web platforms.",
      iconColor: "#22d3ee",
    },
    {
      icon: "/images/services/website/secure.webp",
      title: "Fast Delivery",
      desc: "Single codebase enables quicker development and deployment.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/clean_code.webp",
      title: "Native Feel",
      desc: "Pre-built UI components for smooth, native-like experience.",
      iconColor: "#34d399",
    },
  ],
  floatingIcons: [
    {
      image: "/images/services/website/nodejs.webp",
      top: "16%",
      right: "8%",
      containerSize: 80,
      iconSize: 60,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
    {
      image: "/images/services/website/reactjs.svg",
      top: "8%",
      right: "16%",
      containerSize: 70,
      iconSize: 50,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
  ],
};
// Add this to the bottom of src/utils/mock/ionicAppData.js
export const ionicTechStack = ["Ionic", "Angular", "React", "Vue", "Capacitor", "JavaScript", "TypeScript"];
// 2. Stats Data
export const ionicStatsData = [
  {
    icon: LuSettings,
    value: "150+",
    label: "Apps Built",
    colorClass: "text-[#00d2ff]",
    bgClass: "bg-[#00d2ff]/10",
    borderClass: "border-[#00d2ff]/20",
    glowClass: "shadow-[0_0_20px_rgba(0,210,255,0.15)]",
  },
  {
    icon: LuUsers,
    value: "90+",
    label: "Happy Clients",
    colorClass: "text-[#a855f7]",
    bgClass: "bg-[#a855f7]/10",
    borderClass: "border-[#a855f7]/20",
    glowClass: "shadow-[0_0_20px_rgba(168,85,247,0.15)]",
  },
  {
    icon: LuSmartphone,
    value: "50M+",
    label: "Downloads",
    colorClass: "text-[#06b6d4]",
    bgClass: "bg-[#06b6d4]/10",
    borderClass: "border-[#06b6d4]/20",
    glowClass: "shadow-[0_0_20px_rgba(6,182,212,0.15)]",
  },
  {
    icon: LuShieldCheck,
    value: "99.9%",
    label: "Crash-Free Apps",
    colorClass: "text-[#3b82f6]",
    bgClass: "bg-[#3b82f6]/10",
    borderClass: "border-[#3b82f6]/20",
    glowClass: "shadow-[0_0_20px_rgba(59,130,246,0.15)]",
  },
  {
    icon: LuPercent,
    value: "40%",
    label: "Faster Development",
    colorClass: "text-[#d946ef]",
    bgClass: "bg-[#d946ef]/10",
    borderClass: "border-[#d946ef]/20",
    glowClass: "shadow-[0_0_20px_rgba(217,70,239,0.15)]",
  },
  {
    icon: LuShield,
    value: "100%",
    label: "Client Satisfaction",
    colorClass: "text-[#6366f1]",
    bgClass: "bg-[#6366f1]/10",
    borderClass: "border-[#6366f1]/20",
    glowClass: "shadow-[0_0_20px_rgba(99,102,241,0.15)]",
  },
];

// 3. Solutions and Process Data
export const ionicSolutionsAndProcessData = {
  buildSubtitle: "WHAT WE BUILD",
  buildTitle: "Ionic Enterprise Solutions for Modern Applications",
  buildCards: [
    {
      title: "Ionic Cross-Platform Apps",
      desc: "Build scalable mobile and web applications using a single Ionic codebase.",
      icon: LuSmartphone,
      colorClass: "text-[#3880ff]",
      bgClass: "bg-[#3880ff]/10",
      borderClass: "border-[#3880ff]/20 hover:border-[#3880ff]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(56,128,255,0.25)]",
    },
    {
      title: "Capacitor Integration",
      desc: "Access native device features like camera, GPS, and storage via Capacitor bridge.",
      icon: LuCpu,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "Progressive Web Apps (PWA)",
      desc: "Create fast, installable, and offline-capable web applications.",
      icon: FiGlobe,
      colorClass: "text-[#a855f7]",
      bgClass: "bg-[#a855f7]/10",
      borderClass: "border-[#a855f7]/20 hover:border-[#a855f7]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(168,85,247,0.25)]",
    },
    {
      title: "Enterprise Ionic Solutions",
      desc: "Develop secure and scalable applications for complex business operations.",
      icon: LuBuilding2,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
    {
      title: "UI Component System",
      desc: "Use reusable Ionic UI components for faster development and consistent design.",
      icon: LuLayers,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "Performance Optimization",
      desc: "Improve speed, responsiveness, and overall app efficiency across all devices.",
      icon: FiZap,
      colorClass: "text-[#f59e0b]",
      bgClass: "bg-[#f59e0b]/10",
      borderClass: "border-[#f59e0b]/20 hover:border-[#f59e0b]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(245,158,11,0.25)]",
    },
  ],
  processSubtitle: "OUR DEVELOPMENT PROCESS",
  processTitle: "Ionic Development Lifecycle",
  processSteps: [
    {
      step: "01",
      title: "Discovery",
      description: "Understand goals, requirements, and choose optimal Ionic technology stack.",
      icon: LuSearch,
    },
    {
      step: "02",
      title: "UI/UX Design",
      description: "Create modern, responsive, and web-standard interface designs.",
      icon: LuPalette,
    },
    {
      step: "03",
      title: "Development",
      description: "Build hybrid applications using Ionic framework and Capacitor integration.",
      icon: LuCode,
    },
    {
      step: "04",
      title: "Testing",
      description: "Ensure cross-platform performance, stability, and device compatibility.",
      icon: LuBug,
    },
    {
      step: "05",
      title: "Deployment",
      description: "Launch apps across iOS, Android, and web platforms with full support.",
      icon: LuCircleCheck,
    },
    {
      step: "06",
      title: "Maintenance",
      description: "Provide updates, bug fixes, and continuous performance improvements.",
      icon: LuRocket,
    },
  ],
  benefitsSubtitle: "WHY CHOOSE IONIC?",
  benefitsTitle: "Future-Ready Web & Mobile Framework",
  benefits: [
    "Single codebase for iOS, Android, and Web",
    "Uses familiar Web Standards (HTML, CSS, JS)",
    "Huge library of pre-built UI components",
    "Seamless integration with Capacitor bridge",
    "Rapid development and faster prototyping",
    "Excellent support for Progressive Web Apps (PWAs)",
    "Scalable cross-platform app architecture",
  ],
  logoImage: "/images/serviceBanners/IonicBanner.webp",
  whiteLogoImage: "/images/serviceBanners/IonicBannerW.webp",
};

// 4. Portfolio Data
export const ionicPortfolioData = {
  subtitle: "OUR WORK",
  title: "Ionic Apps That Scale",
  buttonText: "View All Projects",
  buttonLink: "#",
  apps: [
    {
      title: "LogiTrack",
      badge: "Logistic App",
      badgeColor: "bg-[#3880ff]/10 text-[#3880ff] border-[#3880ff]/20",
      desc: "A powerful logistics management tool built with Ionic for real-time fleet tracking.",
      downloads: "50K+",
      rating: "4.7",
      image: "/images/MobileAppDevelopment/cross_platform_development.png",
    },
  ],
};

// 5. Technologies Data
export const ionicTechnologiesData = {
  techTitle: "TECHNOLOGIES WE USE",
  technologies: [
    { name: "Ionic", icon: "Ionic" },
    { name: "Angular", icon: "Angular" },
    { name: "React", icon: "React" },
    { name: "Vue", icon: "Vue" },
    { name: "Capacitor", icon: "Capacitor" },
    { name: "TypeScript", icon: "TypeScript" },
  ],
  trustTitle: "TRUSTED BY BUSINESSES",
  trustClients: [
    { image: "/images/logo/google_logo.png", alt: "google_logo" },
    { image: "/images/logo/microsoft_logo.png", alt: "microsoft_logo" },
    { image: "/images/logo/amazon_logo.png", alt: "amazon_logo" },
    { image: "/images/logo/Adobe_Corporate_logo.png", alt: "adobe_logo" },
    { image: "/images/logo/IBM_logo.png", alt: "ibm_logo" },
    { image: "/images/logo/Oracle_logo.png", alt: "oracle_logo" },
  ],
};

// 6. About Data
export const ionicAboutData = [
  {
    title: "Ionic App Development Company for Cross-Platform Digital Experiences",
    content: (
      <>
        Modern businesses need mobile applications that work smoothly across devices without increasing development complexity or operational costs. A trusted{" "}
        <b className="text-text-primary font-semibold">ionic app development company</b> helps organizations create scalable applications that improve accessibility, customer
        engagement, and business efficiency. Many businesses struggle with maintaining separate apps for different platforms, which slows growth and increases maintenance
        challenges. At <b className="text-text-primary font-semibold">Tycho Technologies</b>, Ionic applications are developed around business objectives, usability, and long-term
        scalability to help companies create flexible digital ecosystems.
      </>
    ),
  },
  {
    title: "Hybrid Mobile App Development for Better Business Flexibility",
    content: (
      <>
        Building applications for multiple platforms has become essential for businesses aiming to improve customer reach and engagement. Reliable{" "}
        <b className="text-text-primary font-semibold">hybrid mobile app development</b> helps organizations create smooth digital experiences while reducing time spent on
        platform-specific development. Companies investing in <b className="text-text-primary font-semibold">ionic mobile app development services</b> often benefit from better
        flexibility because applications can adapt to evolving customer expectations across mobile and web environments. Tycho Technologies focuses on practical Ionic strategies
        designed to improve performance while supporting long-term business growth.
      </>
    ),
  },
  {
    title: "Cross Platform App Developers for Scalable Mobile Solutions",
    content: (
      <>
        Businesses looking to improve digital accessibility often require applications that remain responsive and efficient across operating systems. Experienced{" "}
        <b className="text-text-primary font-semibold">cross platform app developers</b> help organizations simplify app management while supporting stronger user experiences and
        operational efficiency. Companies aiming to strengthen mobile ecosystems frequently align modern development strategies with{" "}
        <a href="https://tychotechnologies.com/react-native-app-development-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          react native app development company
        </a>{" "}
        solutions to improve flexibility and support connected digital experiences.
      </>
    ),
  },
  {
    title: "Why Businesses Choose an Ionic App Development Company in India",
    content: (
      <>
        The demand for a trusted <b className="text-text-primary font-semibold">ionic app development company in india</b> continues to grow as businesses seek scalable and
        cost-effective application development solutions. Companies investing in <b className="text-text-primary font-semibold">ionic app development services india</b> often
        prioritize usability, faster adaptability, and stronger digital accessibility. Businesses partnering with Tycho Technologies gain access to customized Ionic frameworks
        designed around measurable business goals and user expectations. Many organizations also strengthen content-driven ecosystems through{" "}
        <a href="https://tychotechnologies.com/ott-platform-development-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          ott app development company
        </a>{" "}
        solutions to support broader digital engagement strategies.
      </>
    ),
  },
];

// 7. FAQs (Preserved and updated)
export const ionicFaqs = [
  {
    q: "Why should I choose Ionic app development in India for my project?",
    a: "Ionic app development in India provides cost-effective solutions with skilled developers who can build cross-platform apps using a single codebase, saving time and money.",
  },
  {
    q: "What are the benefits of developing an app with Ionic?",
    a: "It lets you create fast, responsive, and visually appealing apps for multiple platforms using a single codebase, ensuring consistent performance and quicker time-to-market.",
  },
];
